import { TrustSignal } from "./types";
import { BadgeCheck, Lock, ShieldCheck, Package, RefreshCcw, Undo2, Award, Star, Wrench } from "lucide-react";
export const TRUST_SIGNALS: TrustSignal[] = [{
  id: "secure-payments",
  label: "Secure Payments",
  description: "Encrypted & protected checkout",
  desktopIcon: <BadgeCheck className="w-9 h-9" strokeWidth={1} />,
  desktopBadge: <Lock className="w-full h-full" strokeWidth={2} />,
  mobileIcon: <ShieldCheck className="w-8 h-8" strokeWidth={1} />
}, {
  id: "easy-returns",
  label: "Easy Returns",
  description: "Simple returns. Fast refunds.",
  desktopIcon: <Package className="w-9 h-9" strokeWidth={1} />,
  desktopBadge: <RefreshCcw className="w-full h-full" strokeWidth={2} />,
  mobileIcon: <Undo2 className="w-8 h-8" strokeWidth={1} />
}, {
  id: "verified-sellers",
  label: "Verified Sellers",
  description: "Vetted for pure craft",
  desktopIcon: <Award className="w-9 h-9" strokeWidth={1} />,
  desktopBadge: <Star className="w-full h-full" strokeWidth={2} />,
  mobileIcon: <Wrench className="w-8 h-8" strokeWidth={1} />
}];